import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '@/components/ConfirmModal';

interface DeleteAccountModalProps {
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}

const DeleteAccountModal: FC<DeleteAccountModalProps> = ({ open, onCancel, onOk }) => {
  const { t } = useTranslation();

  return (
    <ConfirmModal
      open={open}
      icon="warning"
      iconBgColor="var(--yellow-10)"
      iconColor="var(--yellow-100)"
      title={t('profile.deleteAccountModal.title')}
      description={t('profile.deleteAccountModal.description')}
      confirmText={t('profile.deleteAccountModal.delete')}
      cancelText={t('profile.deleteAccountModal.cancel')}
      onConfirm={onOk}
      onCancel={onCancel}
    />
  );
};

export default DeleteAccountModal;
